<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading || saving"></Loader>
		<div class=" container" >	
			
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Clientes</li>
						</ol>
						<div class="title">
							<h1>Clientes</h1>
						</div>
						<div class="cta">
							
						</div>
					</div>


					<b-form class="mt-4" @submit.prevent="save" v-if="!loading" novalidate >
						
						<b-form-group label="Nombre" >
							<b-form-input
								v-model="form.name"
								placeholder="Nombre fantasia"
								:state="!validation.hasError('form.name')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese un nombre válido</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group label="Razón social" class="mt-2" >
							<b-form-input
								v-model="form.business_name"
								placeholder="Razón social"
								:state="!validation.hasError('form.business_name')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese un nombre válido</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="Email" class="mt-2">
							<b-form-input
								v-model="form.email"
								type="email"
								placeholder="Correo electrónico"
								:state="!validation.hasError('form.email')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese un dirección de email válida</b-form-invalid-feedback>
						</b-form-group>


						<phone-input  class="mt-2"
							label="Teléfono"
							placeholder="Teléfono"
							v-model="form.phone"
							@changed="checkValidation"
							:defaultCountry="form.phone.countryCode"
							:hasError="validation.hasError('form.phone.validated')"
						></phone-input>
								
						
						<div class="overflow-hidden mt-4">
							<b-button @click="$router.go(-1)" type="button" class="pull-left" size="sm" variant="light">Volver</b-button>
							<b-button type="submit" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
						</div>
						
						<b-button type="button" @click="deletePrompt" block v-if="action=='update'" variant="outline-danger" class="btn-delete mt-4">Suspender cliente</b-button>
						
					</b-form>

				</div>
			</div>
		</div>
	</div>
	
	

	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import PhoneInput from '@/components/PhoneInput'
import Navbar from '@/components/Navbar'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'AccountModal',
	mixins:[mixins],
	components:{
		Loader,
		PhoneInput,
		Navbar,
	},
	data () {
		return {
			action: 'create',
			form: {
				name: null,
				business_name: null,
				email: null,
				phone: {
					validated: false
				},
			},
			loading: true,
			saving: false,
		}
	},
	validators: {
		'form.name': function (value) {
			return Validator.value(value).required();
		},
		'form.business_name': function (value) {
			return Validator.value(value).required();
		},
		'form.email': function (value) {
			return Validator.value(value).required().email();
		},
		'form.phone.validated': function (value) {
			return Validator.custom( () => {
				if(!value){
					return "ingrese un telefono valido"
				}
			})
		},	
	},
	beforeMount(){
		if( this.$route.params.id > 0 ){
			this.action = 'update'
			this.load(this.$route.params.id)
		}else{
			this.loading = false
		}
	},
	methods: {
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					client (id: $id) {
						id
						name
						business_name
						email
						phone{
							countryCode
							national
							international
							type
							validated
						}
					}
				}`,
				variables: {
					id
				},
			})
			.then((data) => {
				this.form = data.data.client;
				this.loading = false
				this.$emit('loaded')
			});
		},
		checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					name 		: this.form.name,
					business_name : this.form.business_name,
					email 		: this.form.email,
					phone 		: this.form.phone,
				}
				if(this.action == 'create' ){
					this.create(dataInput)
				}else
				if(this.action == 'update' ){
					this.update(this.form.id, dataInput)
				}
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:ClientInput! ){
					clientCreate( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				this.saving = false
				// this.$router.go(-1)
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
		update (id, data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data:ClientInput! ){
					clientUpdate( id: $id, data: $data) {
						id
					}
				}`,
				variables: {
					id: id,
					data: data,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		deletePrompt() {
			this.$dialog
			.confirm('¿Está seguro que desea suspender este cliente?')
			.then(() => {
				this.delete()
			})
		},
		delete() {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID! ){
					clientDelete( id: $id) {
						id
					}
				}`,
				variables: {
					id: this.form.id,
				}
			})
			.then(() => {
				this.$toast.success('Elemento eliminado correctamente')
				this.$emit('updated')
				this.saving = false
				this.$router.push('/clients')
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		}
	}
}


</script>
